import React from 'react';
import { Link } from 'react-router-dom';
import { formatDateTime } from '../pages/inquiriesShared';
import './UpcomingAppointmentsCard.css';

const getAppointmentStart = (event) => (
  event?.planned_start_at || event?.planned_end_at || event?.scheduled_at || null
);

const getAssigneeLabel = (event) => {
  const member = event?.assigned_member || event?.task_assigned_member || event?.inquiry_assigned_member;
  return member?.display_name || member?.email || '';
};

const getInquiryTitle = (event) => (
  event?.inquiry?.display_key
  || event?.inquiry?.display_name
  || event?.inquiry?.subject
  || (event?.inbox_id ? `Henvendelse #${event.inbox_id}` : 'Henvendelse')
);

function UpcomingAppointmentsCard({
  events = [],
  loading = false,
  className = '',
  title = 'Kommende avtaler',
}) {
  const visibleEvents = Array.isArray(events) ? events.slice(0, 5) : [];

  return (
    <section className={`card upcoming-appointments-card ${className}`.trim()}>
      <header className="card-header upcoming-appointments-header">
        <div>
          <span className="card-title">{title}</span>
          <p className="upcoming-appointments-subtitle">Planlagte steg for deg og ufordelte saker.</p>
        </div>
        <Link to="/henvendelser/kalender" className="button button-secondary button-small">
          Kalender
        </Link>
      </header>

      {loading ? (
        <div className="upcoming-appointments-empty">Laster avtaler...</div>
      ) : visibleEvents.length === 0 ? (
        <div className="upcoming-appointments-empty">Ingen kommende avtaler.</div>
      ) : (
        <div className="upcoming-appointments-list">
          {visibleEvents.map((event) => {
            const startAt = getAppointmentStart(event);
            const assignee = getAssigneeLabel(event);
            const productName = event?.product?.name || 'Uten produkt';
            const inboxId = event?.inbox_id || event?.inquiry?.id;
            return (
              <Link
                key={`${inboxId || 'event'}-${event.step_key || event.step_id || startAt}`}
                to={inboxId ? `/henvendelser/${inboxId}` : '/henvendelser/kalender'}
                className="upcoming-appointments-row"
              >
                <span className="upcoming-appointments-time">{formatDateTime(startAt)}</span>
                <span className="upcoming-appointments-main">
                  <strong>{event?.step_label || 'Planlagt steg'}</strong>
                  <small>{getInquiryTitle(event)}</small>
                </span>
                <span className="upcoming-appointments-meta">
                  <small>{productName}</small>
                  <small>{assignee || 'Ufordelt'}</small>
                </span>
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
}

export default UpcomingAppointmentsCard;
